// extracted by mini-css-extract-plugin
export default {"spinner":"MoveMessages_spinner__1PS8f"};